import './style.css';

import {Map, View} from 'ol';

import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import MVT from 'ol/format/MVT.js';
import apply from 'ol-mapbox-style';

import {Style, Stroke, Circle, Fill} from 'ol/style';
import LayerGroup from 'ol/layer/Group.js';
import Collection from 'ol/Collection.js';
import Overlay from 'ol/Overlay.js';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';

import GeoJSON from 'ol/format/GeoJSON';
import GPX from 'ol/format/GPX';

import PinchZoom from 'ol/interaction/PinchZoom.js';

import {useGeographic} from 'ol/proj';
useGeographic();

import Wanderpunkte from './andreasberge/Wanderpunkte';
import Styles from './andreasberge/Styles';
import RouteHelper from './andreasberge/RouteHelper';
import RouteBuilder from './andreasberge/RouteBuilder';
import log from './andreasberge/logger.js';

const andreasbergeLayers = {};

const junctionsSource = new VectorSource({
    format: new GPX(),
    url: 'JunctionPoints.gpx'
});
const wegeSource = new VectorSource({
    format: new GPX(),
    url: 'wanderabschnitte.gpx'
});
const pfadeSource = new VectorSource({
    format: new GPX(),
    url: 'wanderpfade.gpx'
});

let junctionsLayer;
let wanderpunkteLayer;
let wegeLayer;
let pfadeLayer;

let editModus = false;
let startOverlay, zielOverlay, optionsOverlay;

let lastJunctionId;
let selectedJunction;
let selectedVerlauf = [];
let selectedWanderabschnitte = [];

const center = [10.519, 51.713];
const map = new Map({
    target: 'map',
    layers: [ ],
    view: new View({
        center: center,
        zoom: 13
    })
});

const basemapLayer = new VectorTileLayer({
    source: new VectorTileSource({
        url: "https://sgx.geodatenzentrum.de/gdz_basemapde_vektor/tiles/v2/bm_web_de_3857/{z}/{x}/{y}.pbf",
        format: new MVT()
    })
});

// Fetch Basemap style
// source https://sgx.geodatenzentrum.de/gdz_basemapde_vektor/styles/bm_web_top.json
// Noto Sans Extracondensed replaced by Noto Sans Regular
fetch("basemap-style.json")
    .then(response => response.json())
    .then(style => {
        map.addLayer(basemapLayer);
        apply(map, style);
        
        startExplorer();
    });

function addVectorLayer(name, vectorSource) {
    log.debug("add layer:", name);
    const vectorLayer = new VectorLayer({
        source: vectorSource,
        style: function (feature) {
            return Styles.getVectorStyle(name, feature);
        }
    });
    map.addLayer(vectorLayer);
    
    if (name == 'junctions') { 
        junctionsLayer = vectorLayer;
    } else if (name == 'wege') {
        wegeLayer = vectorLayer;
    } else if (name == 'pfade') {
        pfadeLayer = vectorLayer;
    } else {
        andreasbergeLayers[name] = vectorLayer;
    }
    
    if (name === 'wegepunkte' || name === 'junctions') {
        vectorSource.once('change', function (e) {
            if (vectorSource.getState() === 'ready') {
                const features = vectorLayer.getSource().getFeatures();
                if (features.length > 0) {
                    const waypoints = [];
                    features.forEach(feature => {
                        if (name === 'junctions') {
                            feature.setId('junction' + feature.getProperties().cmt);
                        }
                        const type = feature.getGeometry().getType();
                        if (type == 'Point') {
                            waypoints.push(feature);
                        }
                    });
                    if (waypoints.length > 0) {
                        let pointLayer;
                        if (name === 'wegepunkte') {
                            pointLayer = Wanderpunkte.getPointLayer(waypoints);
                        } else if (name === 'junctions') {
                            pointLayer = Wanderpunkte.getJunctionLayer(waypoints);
                        }
                        map.addLayer(pointLayer);
                        andreasbergeLayers['JunctionPoints'] = pointLayer;
                    }
                }
                if (name === 'wegepunkte') {
                    const vectorExtent = vectorSource.getExtent();
                    const view = map.getView();
                    view.fit(
                        vectorExtent,
                        {
                            size: map.getSize(),
                            padding: [30, 30, 30, 30]
                        }
                    );
                    if (view.getZoom() > 14) {
                        view.setZoom(14);
                    }
                }
            }
        });
    }
}

function addJunctions(junctionIDs, selected) {
    let jStyle, jType;
    if (typeof selected == 'undefined' || !selected) {
        jStyle = Styles.getJunctionStyle();
        jType = 'JunctionOptions';
    } else {
        jStyle = Styles.getJunctionStyle(selected);
        jType = 'Routepunkte';
    }
        
    const features = new Collection();
    const junctionSource = new VectorSource({
        features: features
    });
    const junctionLayer = new VectorLayer({
        source: junctionSource,
        style: jStyle
    });
    
    map.addLayer(junctionLayer);
    log.debug("added layer: " + jType);
    andreasbergeLayers[jType] = junctionLayer;
    
    for (let i = 0; i < junctionIDs.length; i++) {
        const junctionID = junctionIDs[i];
        RouteBuilder.getJunctionInfos(junctionID).then((junctionData => {
            const junction = new Point([junctionData.punkt.coordinateX,
                                        junctionData.punkt.coordinateY]);
            const feature = new Feature({
                geometry: junction
            });
            if (typeof selected == 'undefined' || !selected) {
                feature.setId('jOption' + junctionData.id);
            }
            features.push(feature);
        }));
    };
}


function displayWege() {
    if (typeof wegeLayer !== 'object') {
        toggleWege();
    }
}
function toggleWege() {
    let checked = false;
    if (typeof wegeLayer == 'object') {
        map.removeLayer(wegeLayer);
        wegeLayer = undefined;
        map.removeLayer(pfadeLayer);
        pfadeLayer = undefined;
    } else {
        addVectorLayer("wege", wegeSource);
        addVectorLayer("pfade", pfadeSource);
        checked = true;
    }
    const input = document.getElementById('wegeBox');
    input.checked = checked;
}

function displayJunctions() {
    if (typeof junctionsLayer == 'undefined') {
        addVectorLayer('junctions', junctionsSource);
        const input = document.getElementById('junctionBox');
        input.checked = true;
    }
}
function toggleJunctions() {
    let checked = false;
    if (typeof junctionsLayer == 'object') {
        map.removeLayer(andreasbergeLayers['JunctionPoints']);
        delete andreasbergeLayers['JunctionPoints'];

        map.removeLayer(junctionsLayer);
        junctionsLayer = undefined;
    } else {
        log.debug("display junctions");
        addVectorLayer('junctions', junctionsSource);
        checked = true;
    }
    const input = document.getElementById('junctionBox');
    input.checked = checked;
}

function toggleWanderpunkte() {
    let checked = false;
    if (typeof wanderpunkteLayer == 'object') {
        map.removeLayer(wanderpunkteLayer);
        wanderpunkteLayer = undefined;
    } else {
        displayWanderpunkte();
        checked = true;
    }
    const input = document.getElementById('wanderpunkteBox');
    input.checked = checked;
}

function startExplorer() {
    editModus = false;
    if (typeof startOverlay == 'object') {
        startOverlay.setPosition(undefined);
    }
    if (typeof zielOverlay == 'object') {
        zielOverlay.setPosition(undefined);
    }
    
    resetView();
    resetRoute();
    
    displayJunctions();
    displayWege();

    const routeInfo = document.getElementById('routeInfo');
    routeInfo.innerHTML = '<p>Wähle einen der grünen Markierungen als Startpunkt</p>';

    map.getView().setZoom(15);
    map.getView().setCenter(center);
}



// display selected wanderabschnitte from GEOJSON files
function displaySelectedWanderabschnitte() {
    const IDs = [];
    selectedWanderabschnitte.forEach((verbindung => {
        IDs.push(verbindung.wanderabschnitt);
    }));
    displayWanderabschnitte(IDs, 0, true);
}
function displayOptionalWanderabschnitte(options) {
    const IDs = [];
    for (const option of options) {
        IDs.push(option.wanderabschnitt);
    }
    displayWanderabschnitte(IDs, 0, false);
}

// show wanderabschnitte from GEOJSON files
function displayWanderabschnitte(abschnitte, zoomLevel, selected) {
    if (typeof zoomLevel === 'undefined') {
        zoomLevel = 13;
    }

    for (let i = 0; i < abschnitte.length; i++) {
        const id = abschnitte[i];
        const vectorSource = new VectorSource({
            format: new GeoJSON(),
            url: './data/wanderabschnitt/' +  id + '.geojson',
            projection: 'ESPG:3857'
        });
        
        if (zoomLevel > 0) {
            vectorSource.once('change', function (e) {
                if (vectorSource.getState() === 'ready') {
                    const mapsize = map.getSize();
                    map.getView().setZoom(zoomLevel);
                    map.getView().centerOn(center,
                                           mapsize,
                                           [mapsize[0]/2, mapsize[1]/2]);
                }
            });
        }

        let aStyle, layerName, zIndex;
        if (typeof selected == 'undefined') {
            aStyle = Styles.getWanderabschnittStyle();
        } else {
            aStyle = Styles.getWanderabschnittStyle(selected);
        }
            
        const abschnittLayer = new VectorLayer({
            source: vectorSource,
            style: aStyle
        });
        map.addLayer(abschnittLayer);
        andreasbergeLayers['Abschnitt' + id] = abschnittLayer;
    }
}

function displayWanderpunkte() {
    RouteBuilder.getWanderpunkte().then(geojson => {
        const format = new GeoJSON({});
        const features = format.readFeatures(geojson, {
            featureProjection: 'EPSG:4326'
        });
        wanderpunkteLayer = Wanderpunkte.getWanderpunkteLayer(features);
        map.addLayer(wanderpunkteLayer);
    });
}


function resetRoute() {
    selectedJunction = undefined;
    selectedWanderabschnitte = [];
    selectedVerlauf = [];
}

function resetView() {
    log.debug("reset view");
    removeAndreasbergeLayers();

    const routeOptions = document.getElementById('routeOptions');
    routeOptions.innerHTML = "";
    RouteHelper.removeRouteInfo();
}
function removeAndreasbergeLayers() {
    const layerNames = Object.keys(andreasbergeLayers);
    layerNames.forEach(name => {
        if (name !== 'JunctionPoints' && name !== 'junctions'
            && name !== 'wege'&& name !== 'pfade') {
            log.debug("remove layer: " + name);
            map.removeLayer(andreasbergeLayers[name]);
            delete andreasbergeLayers[name];
        }
    });
    // should not be necessary, but above code doesn't remove all wegeabschnitt layers
    const remainingLayers = map.getAllLayers();
    remainingLayers.forEach(layer => {
        const src = layer.getSource();
        if (src !== null && typeof src.getUrl == 'function') {
            const url = src.getUrl();
            if (typeof url !== 'undefined' && url.indexOf('data/wanderabschnitt') > -1) {
                log.debug("remove leftover layer: " + url);
                map.removeLayer(layer);
            }
        }
    });
}



function getRouteGPX() {
    if (selectedWanderabschnitte.length > 1) {
        RouteBuilder.postRoute(selectedVerlauf[0][0], selectedWanderabschnitte);
    }
}

function removeLast() {
    editModus = true;
    if (typeof zielOverlay == 'object') {
        zielOverlay.setPosition(undefined);
    }
    
    log.debug("selectedVerlauf", selectedVerlauf);
    if (selectedVerlauf.length < 3) {
        startExplorer();
        return;
    }

    resetView();
    selectedWanderabschnitte.pop();
    selectedWanderabschnitte.pop();
    selectedVerlauf.pop();
    const junction = selectedVerlauf.pop();
    const junctionID = junction[0];

    const prevJunction = selectedVerlauf[selectedVerlauf.length - 1];
    const prevJunctionID = prevJunction[0];
    

    RouteBuilder.getJunctionInfos(prevJunctionID)
        .then((junctionData => {
            selectedJunction = junctionData;
            onJunctionSelected(junctionID);
        }));
}

function routeFinished() {
    resetView();

    displaySelectedWanderabschnitte();

    const junctionX = selectedJunction.punkt.coordinateX;
    const junctionY = selectedJunction.punkt.coordinateY;
    const junctionPos = [junctionX, junctionY];
    showZielMarker(junctionPos);
    
    RouteBuilder.showRouteInfos(selectedWanderabschnitte,
                                selectedVerlauf);

    // move junctions layer on top
    if (typeof junctionsLayer == 'object') {
        toggleJunctions();
        toggleJunctions();
    }
}

function onJunctionSelected(junctionId, wanderabschnittId) {
    log.info("junction selected", junctionId);
    resetView();

    if (typeof selectedJunction !== 'undefined') {
        addJunctions([junctionId], true);
        
        lastJunctionId = selectedJunction.id;
        const possibilities = [];
        selectedJunction.verbindungen.forEach(verbindung => {
            if (verbindung.junction == junctionId) {
                if (typeof wanderabschnittId !== 'undefined') {
                    if (verbindung.wanderabschnitt == wanderabschnittId) {
                        possibilities.push(verbindung);
                    }
                } else {
                    possibilities.push(verbindung);
                }
            }
        });
        if (possibilities.length > 1) {
            displayOptionalWanderabschnitte(possibilities);
            showRouteOptions(junctionId, possibilities);
        } else {
            selectedWanderabschnitte.push(possibilities[0]);
            procSelectedJunction(junctionId);
        }
    } else {
        procSelectedJunction(junctionId);
    }
}

function showStartMarker(junctionPos) {
    log.debug('show Start');
    editModus = true;

    if (typeof startOverlay == 'undefined') {
        const element = document.getElementById('startMarker');
        element.style.display = 'block';
        startOverlay = addOverlay(junctionPos, element, 'startOver');
    } else {
        startOverlay.setPosition(junctionPos);
    }
}
function showZielMarker(junctionPos) {
    log.debug('show Ziel');
    if (typeof zielOverlay == 'undefined') {
        const element = document.getElementById('zielMarker');
        element.style.display = 'block';
        zielOverlay = addOverlay(junctionPos, element, 'zielOver');
    } else {
        zielOverlay.setPosition(junctionPos);
    }
}
function showRouteOptions(junctionId, possibilities) {
    log.debug('show route options');
    RouteBuilder.showPossibilities(junctionId, possibilities);

    const junctionX = selectedJunction.punkt.coordinateX;
    const junctionY = selectedJunction.punkt.coordinateY;
    const junctionPos = [junctionX, junctionY];

    if (typeof optionsOverlay == 'undefined') {
        const element = document.getElementById('routeOptions');
        element.style.display = 'block';
        optionsOverlay = addOverlay(junctionPos, element,
                                    'optionsOver', 'center-left');
        optionsOverlay.setOffset([50,0]);
        
        RouteBuilder.setOptionsOverlay(optionsOverlay);
    } else {
        optionsOverlay.setPosition(junctionPos);
    }
}

function addOverlay(position, element, id, positioning) {
    if (typeof positioning === 'undefined') {
        positioning = 'center-center';
    }
    const overlay = new Overlay({
        id: id,
        position: position,
        positioning: positioning,
        element: element,
        stopEvent: false
    });
    map.addOverlay(overlay);

    return overlay;
}

function procSelectedJunction(junctionId) {
    displaySelectedWanderabschnitte();
    
    RouteBuilder.getJunctionInfos(junctionId).then((junctionData => {
        selectedJunction = junctionData;
        selectedVerlauf.push([junctionId, junctionData.code]);

        const mapsize = map.getSize();
        // center view at selected junction
        const junctionX = junctionData.punkt.coordinateX;
        const junctionY = junctionData.punkt.coordinateY;
        const junctionPos = [junctionX, junctionY];
        map.getView().centerOn(junctionPos,
                               mapsize,
                               [mapsize[0]/2, mapsize[1]/2]
                              );

        if (selectedWanderabschnitte.length == 0) {
            showStartMarker(junctionPos);
        }
        
        const junctionIDs = [];
        const wanderabschnitte = [];

        const verbindungen = junctionData.verbindungen;
        verbindungen.forEach((verbindung => {
            const junctionID = verbindung.junction;
            if (lastJunctionId !== junctionID) {
                junctionIDs.push(junctionID);
                const abschnittID = verbindung.wanderabschnitt;
                wanderabschnitte.push(abschnittID);
            }
        }));
        displayWanderabschnitte(wanderabschnitte, 0);
        addJunctions(junctionIDs);
        RouteBuilder.showRouteInfos(selectedWanderabschnitte,
                                    selectedVerlauf);
        // move junctions layer on top
        if (typeof junctionsLayer == 'object') {
            toggleJunctions();
            toggleJunctions();
        }
    }));
    
}

let block = false;
function unblock() {
    block = false;
}

map.on("singleclick", function(e) {
    log.debug('click event', e);
    handleUserEvent(e.pixel);
});

function handleUserEvent(coord) {
    if (block) {
        return;
    } else {
        block = true;
        setTimeout(unblock, 100);
    }
    log.debug('coordinate', coord);    
    if (!map.hasFeatureAtPixel(coord)) {
        return;
    }
    map.forEachFeatureAtPixel(coord, function (feature, layer) {
        const featureId = feature.getId();
        if (typeof featureId !== 'undefined') {
            log.info('feature with ID', featureId);
            if (editModus && featureId.indexOf('jOption') == 0) {
                const junctionId = featureId.substring(7);
                onJunctionSelected(junctionId);
                return true;
            } else if (!editModus && featureId.indexOf('junction') == 0) {
                const junctionId = featureId.substring(8);
                onJunctionSelected(junctionId);
                return true;
            }
        }
    });
};

window.map = map;
window.document.startExplorer = startExplorer;
window.document.removeLast = removeLast;
window.document.routeFinished = routeFinished;
window.document.postRoute = getRouteGPX;
window.document.onJunctionSelected = onJunctionSelected;
window.document.toggleWege = toggleWege;
window.document.toggleWanderpunkte = toggleWanderpunkte;
window.document.toggleJunctions = toggleJunctions;

window.addEventListener('load', (event) => {
    document.getElementById('map').addEventListener('touchstart', function (e) {
        log.debug('touchstart', e);
        const coord = map.getEventPixel(e);
        handleUserEvent(coord);
    });
});
